module.exports = __webpack_public_path__ + "static/media/loading_bg001.85fdbaa5.png";